import styled from '@emotion/styled';
import { mq } from '../../../../styles/mixins';
import { css } from '@emotion/react';

type StageDescriptionType = {
  isOpen: boolean;
};

export const StageWrapper = styled.div<StageDescriptionType>`
  box-sizing: border-box;
  user-select: none;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  padding: 1.5rem;
  width: 100%;
  min-width: 18rem;
  max-width: 296px;
  margin: 0 auto 0.5rem auto;
  box-shadow: 0 4.0354px 4.0354px rgba(0, 0, 0, 0.25);
  border-radius: 1rem;
  min-height: 612px;
  max-height: 612px;
  justify-content: space-between;
  transition: min-height, max-height 0.25s ease-in-out;
  background-color: ${({ theme }) => theme.colors.core_white};

  ${({ isOpen }) =>
    isOpen &&
    css`
      min-height: auto;
      max-height: 100%;
    `}

  ${mq.smallIp(css`
    min-width: 23.4375rem;
  `)};

  ${mq.small(css`
    min-width: 29.375rem;
  `)};

  ${mq.medium(css`
    min-height: 729px;
    max-height: 729px;
    margin: 0 0 0.5rem 0;
  `)};

  ${mq.large(css`
    min-width: 29.375rem;
  `)};
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Button = styled.div`
  background-color: transparent;
  border: none;
  box-shadow: none;
  font-size: 1rem;
  line-height: 1.5rem;
  font-family: ${({ theme }) => theme.font.nunito};
  color: ${({ theme }) => theme.colors.primary};
  letter-spacing: 0.0125rem;
  align-self: flex-start;
  margin-bottom: 1rem;
`;

export const StageTitle = styled.p`
  font-family: ${({ theme }) => theme.font.questrial};
  font-size: 1.5rem;
  line-height: 2rem;
  color: ${({ theme }) => theme.colors.core_black};
  font-weight: 400;
  margin: 0 0 1rem 0;
  text-align: left;

  ${mq.medium(css`
    font-size: 2rem;
    line-height: 2.5rem;
    margin-bottom: 1.5rem;
  `)};
`;

export const StageDescription = styled.p<StageDescriptionType>`
  margin: 0 0 1rem 0;
  font-size: 1rem;
  line-height: 2rem;
  letter-spacing: 0.0125rem;
  font-family: ${({ theme }) => theme.font.nunito};
  font-weight: 300;
  text-align: left;
  max-height: 18rem;
  white-space: pre-line;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: max-height 0.25s ease-in-out;

  ${({ isOpen }) =>
    isOpen &&
    css`
      max-height: 40rem;
    `}

  ${mq.medium(css`
    margin-bottom: 1.5rem;
    max-height: unset;
  `)};
`;

export const StageImageWrapper = styled.div`
  display:flex;
  justify-self:center;
  align-self: flex-end;
  border-radius: 1rem;
  max-height: 13.25rem;

  ${mq.smallIp(css`
    max-height: 13.25rem;
    max-width: 15.5rem;
    justify-self:center;
  `)};

  ${mq.small(css`
    max-width: 20rem;
    max-height: unset;
  `)};

  ${mq.medium(css`
    justify-self:unset;
    max-height: unset;
    max-width: unset;
  `)};

  img {
    border-radius: 1rem;
    max-height: 13.25rem;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;

    ${mq.smallIp(css`
      max-height: 13.25rem;
      max-width: 15.5rem;
    `)};
    ${mq.small(css`
      max-width: 20rem;
      max-height: unset;
    `)};

    ${mq.medium(css`
      max-height: unset;
      max-width: unset;
    `)};
  }
`;
